import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import ListView from './index';

const queryClient = new QueryClient();

const ListViewWrapper = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ListView {...props} />
    </QueryClientProvider>
  );
}

export default ListViewWrapper;
